import {
  MANDATES_GET,
  MANDATES_HOLDINGS_GET,
  MANDATES_KPIS_GET,
  MANDATES_PERFORMANCE_GET,
  MANDATES_DETAILS_GET,
  MANDATES_ALERT,
  MANDATES_MAX_DRAWDOWN_GET,
  MANDATES_OPTIMIZATION_GET,
} from '../actions/types';

const initialState = {
  items: [],
  holdings: {},
  kpis: {},
  performance: {},
  sectorAllocation: {},
  geoAllocation: {},
  assetClassAllocation: {},
  currencies: {},
  maxDrawdowns: {},
  alerts: [],
  filters: {},
  optimizations: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MANDATES_GET._SUCCESS: {
      const { mandates, filters } = action.payload;
      state.items = mandates;
      state.filters = filters ?? state.filters;
      return state;
    }
    case MANDATES_HOLDINGS_GET._SUCCESS: {
      const { mandateId, holdings } = action.payload;
      state.holdings[mandateId] = holdings;
      return state;
    }
    case MANDATES_DETAILS_GET._SUCCESS: {
      const { mandateId, mandate } = action.payload;
      state.sectorAllocation[mandateId] = mandate.sectorAllocation;
      state.geoAllocation[mandateId] = mandate.geoAllocation;
      state.assetClassAllocation[mandateId] = mandate.assetClassAllocation;
      state.currencies[mandateId] = mandate.currencies;
      const mandateIndex = state.items.findIndex((m) => m.id === mandateId);
      if (mandateIndex !== -1) {
        state.items[mandateIndex] = mandate;
      } else {
        state.items.push(mandate);
      }
      return state;
    }
    case MANDATES_KPIS_GET._SUCCESS: {
      const { mandateId, kpis } = action.payload;
      state.kpis[mandateId] = kpis;
      return state;
    }
    case MANDATES_MAX_DRAWDOWN_GET._SUCCESS: {
      const { mandateId, maxDrawdown } = action.payload;
      state.maxDrawdowns[mandateId] = maxDrawdown;
      return state;
    }
    case MANDATES_OPTIMIZATION_GET._SUCCESS: {
      const { mandateId, optimization, targetReturn } = action.payload;
      state.optimizations[mandateId] = { ...optimization, targetReturn };
      return state;
    }
    case MANDATES_PERFORMANCE_GET._SUCCESS: {
      const {
        mandateId,
        performanceChartYearsTag,
        performanceChartBenchmarkId,
        performanceChart,
        compareIds,
      } = action.payload;

      if (compareIds) {
        state.performance[mandateId][`compare${compareIds}`] = {
          performanceChartBenchmarkId,
          performanceChart,
          performanceChartYearsTag,
        };
      } else {
        state.performance[mandateId] = {
          performanceChartBenchmarkId,
          performanceChart,
          performanceChartYearsTag,
        };
      }

      return state;
    }
    case MANDATES_ALERT: {
      state.alerts.push({
        timestamp: Date.now(),
        message: action.payload.message,
        type: action.payload.type,
      });
      return state;
    }
    default:
      return state;
  }
};

export { reducer as mandates };
